module.exports = __webpack_public_path__ + "static/media/conagra-light-logo.f26415d7.webp";